import { Card, Text, Title } from "../UI";
import style from './RegisterBenefits.module.css';

import iconReservaHora from '../../assets/img/icons/icon-reserva-hora.png';
import iconHistorialMedico from '../../assets/img/icons/icon-historial-medico.png';
import iconExamen from '../../assets/img/icons/icon-examenes.png';
import iconGrupoFamiliar from '../../assets/img/icons/icon-grupo-familiar.png';
import iconDocumentacion from '../../assets/img/icons/icon-docs.png';


export const RegisterBenefits = () => {
    return (
        <Card showOnly="lg" className="lg:py-50 lg:px-70" style={{boxShadow: 'none', border: 'none'}}>
            <Title component="h1" size="20" weight='600'>Beneficios de tener una cuenta en Mi Portal INDISA</Title>
            <div className={style.benefits__description}>Crear una cuenta en Mi Portal INDISA te brinda acceso a una serie de ventajas exclusivas diseñadas para mejorar tu experiencia y facilitar la gestión de tus trámites y servicios de salud. Entre los principales beneficios se encuentran:</div>

            <div className={style.benefits}>
                <div className={style.benefit}>
                    <img src={iconReservaHora} alt="Reserva" className={style.benefit__icon} />
                    <h3 className={style.benefit__title}>Reservar horas</h3>
                    <p className={style.benefit__description}>Agendar citas médicas online de forma rápida y cómoda.</p>
                </div>

                <div className={style.benefit}>
                    <img src={iconHistorialMedico} alt="Historial médico" className={style.benefit__icon} />
                    <h3 className={style.benefit__title}>Ver historial médico</h3>
                    <p className={style.benefit__description}>Accede a tus citas pasadas y futuras en cualquier momento.</p>
                </div>

                <div className={style.benefit}>
                    <img src={iconExamen} alt="Exámenes" className={style.benefit__icon} />
                    <h3 className={style.benefit__title}>Consultar estado de exámenes</h3>
                    <p className={style.benefit__description}>Accede a los resultados de tus exámenes de forma online.</p>
                </div>

                <div className={style.benefit}>
                    <img src={iconGrupoFamiliar} alt="Grupo familiar" className={style.benefit__icon} />
                    <h3 className={style.benefit__title}>Crear grupo familiar</h3>
                    <p className={style.benefit__description}>Gestiona las citas y el historial médico de tus seres queridos.</p>
                </div>

                <div className={style.benefit}>
                    <img src={iconDocumentacion} alt="Documentos" className={style.benefit__icon} />
                    <h3 className={style.benefit__title}>Documentación de atención</h3>
                    <p className={style.benefit__description}>Obtén informes o certificados médicos de manera sencilla.</p>
                </div>
            </div>
        </Card>
    )
}
